module.exports = __webpack_public_path__ + "img/13.c56c7119.png";